import { gql } from '@apollo/client';

export default gql`
  query paymentMethods($bookingReference: String!) {
    paymentMethods(bookingReference: $bookingReference) {
      code
    }
  }
`;
